import { useState, useEffect } from "react";
import axios from 'axiosInstance';
import './css/Inscripciones.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPencil,
  faX,
  
}
from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import Spinner from 'react-bootstrap/Spinner';
import { ListGroup, Row, Col } from 'react-bootstrap';
import { Button, Table } from "react-bootstrap";

function Inscripciones() {
  const [inscripciones, setInscripciones] = useState([]);
  const navegar = useNavigate();
  const [cargando, setCargando] = useState(true);


  const obtenerInscripciones = async () => {
    try {
      const respuesta = await axios.get(process.env.REACT_APP_BACKEND_URL + '/api/inscripciones');
      setInscripciones(respuesta.data);
    } catch (error) {
      console.error("Error al obtener las inscripciones:", error);
    }
    setCargando(false);
  };

  const eliminarInscripcion = async (id) => {
    try {
      await axios.delete(process.env.REACT_APP_BACKEND_URL + `/api/inscripciones/${id}`);
      setInscripciones(inscripciones.filter(i => i.inscripcion_id !== id));
    } catch (error) {
      console.error("Error al eliminar la inscripción:", error);
    }
  };

  const editarInscripcion = (id) => {
    navegar(`/editarInscripcion/${id}`);
  };
  const CrearInscripcion = (id) => {
    navegar(`/CrearInscripcion`);
  };

  useEffect(() => {
    obtenerInscripciones();
  }, []);



return (
  <div className="contenedorEventos p-4">
    <div className="justify-content-between align-items-center mb-4">
      <h1 className="tituloEventos m-3">INSCRIPCIONES</h1>
    </div>

    <div className="d-flex justify-content-between align-items-center mb-4">
      <Button className="boton_agregar" onClick={CrearInscripcion}>Nueva Inscripción</Button>
    </div>
 {cargando ? (
        <div className="text-center my-5">
          <Spinner animation="grow" role="status" />
          <p className="mt-3">Cargando inscripciones...</p>
        </div>
      ) :
    inscripciones && inscripciones.length > 0 ? (
      <Table striped bordered hover responsive className="tabla-inscripciones">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>DNI</th>
            <th>Tutor</th>
            <th>Evento</th>
            <th>Usuario</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {inscripciones.map(inscripcion => (
            <tr key={inscripcion.inscripcion_id}>
              <td className="fila">{inscripcion.nombre} {inscripcion.apellidos}</td>
              <td>{inscripcion.dni}</td>
              <td>{inscripcion.nombre_tutor} {inscripcion.apellidos_tutor}</td>
              <td>{inscripcion.evento?.nombre}</td>
              <td>{inscripcion.user?.name}</td>
              <td>
                <div className="d-flex gap-1 justify-content-center">
                  <Button size="sm" className="boton_accion" onClick={() => editarInscripcion(inscripcion.inscripcion_id)}><FontAwesomeIcon icon={faPencil} size="2x" className="me-2 icono" /> </Button>
                  
                  <Button size="sm"variant="danger"className="boton_accion" onClick={() => eliminarInscripcion(inscripcion.inscripcion_id)}><FontAwesomeIcon icon={faX} size="2x" className="me-2 icono" /></Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <p className=" text-center">
        no hay inscripciones a ningun evento
      </p>
    )}
  </div>
);

}

export default Inscripciones;
